/**
 * little helper to recurse through all the tree of hierarchical data and execute a callback in each node
 *
 * @param data and array of hierarchical data
 * @param cb callback that will be executed in each node
 */
export const recursion: <T extends { children?: Array<T> }>(data: Array<T>, cb: (child: T) => void) => void = (data, cb) => {
  const recursive = (children, callback) => {
    children.forEach((child) => {
      callback(child);
      if (child.children) {
        recursive(child.children, callback);
      }
    });
  };

  recursive(data, cb);
};
